const events = [
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-large-shopping-price-tag-being-torn-in-half-by-two-hands-with-a-burst-of-comparison-arrows-and-receipts-flying-around-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-01&orientation=landscape",
    cat: "带货翻车",
    title: "「全网最低价」放话后，被扒出历史成交价",
    desc: "一句直播间口号，碰上了三个月前的下单记录。价格与承诺之间，差的到底是谁的算盘。",
    date: "08-24",
    time: "6 分钟读完",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-pie-chart-being-split-in-half-by-two-people-pulling-on-two-sides-with-cash-bills-scattered-and-a-small-scale-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-02&orientation=landscape",
    cat: "分成争议",
    title: "流量上来了，账怎么分才不算寒心",
    desc: "从五五开到阶梯式分成，桌面上摆满了方案，桌面下的旧账却没人愿意先算。",
    date: "08-17",
    time: "5 分钟读完",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-small-spotlight-and-crowd-of-arrows-pointing-at-one-person-whose-body-is-fading-into-a-moving-car-with-arrows-leaving-in-opposite-directions-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-03&orientation=landscape",
    cat: "人设反噬",
    title: "一夜爆红之后，人设是怎么悄悄崩塌的",
    desc: "流量来得太快，人设却立得太久。当旧话被重新翻出，涨粉和掉粉只隔着一个转发。",
    date: "08-09",
    time: "7 分钟读完",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-movie-clapperboard-and-a-stack-of-paper-scripts-with-a-gavel-and-a-copyright-symbol-and-two-overlapping-frames-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-04&orientation=landscape",
    cat: "版权风波",
    title: "翻拍爆款没盖章，原创方把官司摆上桌",
    desc: "同一个本子、两套班子，到底算致敬还是算抄？一句「已获授权」能兜住多久。",
    date: "07-28",
    time: "6 分钟读完",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-microphone-and-a-podium-being-handed-over-between-two-people-with-divided-logo-shields-and-confetti-splitting-two-ways-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-05&orientation=landscape",
    cat: "跳槽博弈",
    title: "名嘴跳槽另一家，老东家的话里有话",
    desc: "欢迎新人与声讨背约同时在热搜出现，职业自由与契约的边界再次被拉上台面。",
    date: "07-19",
    time: "5 分钟读完",
  },
  {
    img: "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-a-video-editing-timeline-with-scissors-and-a-question-mark-over-two-split-screens-showing-the-same-scene-differently-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-no-text&width=680&height=460&seq=gw51-card-06&orientation=landscape",
    cat: "剪辑争议",
    title: "一个镜头两种解释，恶意剪辑疑云未散",
    desc: "前因后果被剪掉一半，留下的画面瞬间换了味道。真相在剪辑线之外，也在补刀评论里。",
    date: "07-05",
    time: "8 分钟读完",
  },
];

export default function MoreEvents() {
  return (
    <section id="gengduo" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-archive-line h-4 w-4" />
              更多事件 · 大图卡片流
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              同类故事，换一批接着看
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-foreground-600">
            每一篇都是独立成文的完整复盘，从标题到收尾，无需翻看别处就能看懂全貌。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((e) => (
            <article
              key={e.title}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={e.img}
                  alt={`${e.title} - 五1吃瓜事件详情配图`}
                  className="h-[190px] w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-800 backdrop-blur">
                  {e.cat}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  {e.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{e.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-calendar-line h-3.5 w-3.5" />
                    {e.date}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-time-line h-3.5 w-3.5" />
                    {e.time}
                  </span>
                  <span className="inline-flex items-center gap-1 font-medium text-foreground-700 transition group-hover:text-primary-600">
                    读懂全貌
                    <i className="ri-arrow-right-line h-3.5 w-3.5" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
          >
            加载更多完整复盘
            <i className="ri-loader-4-line h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}